import { safeParse } from "@/utils/safeParse";
import { merge } from "lodash";
import getParent from "../../utils/getParent";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { getAttribute, getFilter } from "./get";
/**
 * 采集点击
 * @param {Element} targetNode
 */
export function material_click(targetNode) {
  const page = getPage();
  const filter = getFilter(page.page_nm);

  const trackData = {
    event_id: 33002,
    event_name: "material_click",
    pin_id: targetNode.getAttribute("data-content-id"),
    board_id: targetNode.getAttribute("data-board-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.pin_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }_${sourceNode.getAttribute("data-content-source")}`;
    } else {
      trackData.pin_source = `${page_nm}_${
        sub_page_nm || ""
      }_${sourceNode.getAttribute("data-content-source")}`;
    }
  } else {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.pin_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }`;
    } else {
      trackData.pin_source = `${page_nm}_${sub_page_nm || ""}`;
    }
  }
  const content_type = getAttribute(targetNode, "data-content-type");
  if (content_type) {
    trackData.content_type = content_type;
  }
  const material_id = targetNode.getAttribute("data-material-id");
  if (material_id) {
    trackData.content_id = material_id;
  }

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.click_source_topic_title = el.getAttribute("data-topic-title");
      trackData.click_source_topic_id = el.getAttribute("data-topic-id");
    }
  }

  if (page_nm === "主题页" || page_nm === "发现页") {
    const el = document.querySelector("[data-sort-type]");
    if (el) {
      trackData.sort_type = el.getAttribute("data-sort-type");
    }
  }

  const file_id = getAttribute(targetNode, "data-file-id");
  if (file_id) {
    trackData.file_id = file_id;
  }

  const ext = getAttribute(targetNode, "data-ext");
  if (ext) {
    Object.assign(trackData, safeParse(ext));
  }

  const material_type = targetNode.getAttribute("data-material-type");
  if (material_type) {
    trackData.material_type = material_type;
  }

  merge(trackData, getFilter(page.page_nm, targetNode));

  reporter(trackData);
}
